'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _dec2, _dec3, _class3, _class4, _temp2;
// import {SlideDown} from 'react-slidedown'
// import { Link as ScrollLink } from 'react-scroll'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _components = require('../../components');

var _Company = require('./Company.css');

var _Company2 = _interopRequireDefault(_Company);

var _search = require('redux/modules/search');

var searchActions = _interopRequireWildcard(_search);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * <ListSlidedowns> component
 * Display: Small alerts for various issues
 * @param company: company object 
 */
var ListSlidedowns = (_dec = (0, _reactCssModules2.default)(_Company2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ListSlidedowns, _Component);

  function ListSlidedowns(props) {
    (0, _classCallCheck3.default)(this, ListSlidedowns);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ListSlidedowns.__proto__ || (0, _getPrototypeOf2.default)(ListSlidedowns)).call(this, props));

    _this.state = {
      labelConfig: {
        is_fff: ['Fossil fuels', 'fff'],
        is_dff: ['Deforestation', 'dff'],
        is_gff: ['Civilian firearms', 'gff'],
        is_pff: ['Prison industrial complex', 'pff'],
        is_wff: ['Military contractor', 'wff'],
        is_tff: ['Tobacco', 'tff'],
        is_sjf: ['Gender equality', 'sjf']
      }
    };
    return _this;
  }
  //


  (0, _createClass3.default)(ListSlidedowns, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (!this.props.company) return null;
      return _react2.default.createElement(
        'div',
        null,
        (0, _entries2.default)(this.state.labelConfig).map(function (_ref) {
          var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
              key = _ref2[0],
              _ref2$ = (0, _slicedToArray3.default)(_ref2[1], 2),
              label = _ref2$[0],
              shortcode = _ref2$[1];

          if (!_this2.props.company[key]) return null;
          return _react2.default.createElement(
            'div',
            { styleName: 'section-wrap', key: key },
            _react2.default.createElement(
              'div',
              { styleName: 'section-label' },
              label
            ),
            key === 'is_fff' ? _react2.default.createElement(_components.CompanyIsFff, { company: _this2.props.company }) : null,
            key === 'is_dff' ? _react2.default.createElement(_components.CompanyIsDff, { company: _this2.props.company }) : null,
            key === 'is_gff' ? _react2.default.createElement(_components.CompanyIsGff, { company: _this2.props.company }) : null,
            key === 'is_pff' ? _react2.default.createElement(_components.CompanyIsPff, { company: _this2.props.company }) : null,
            key === 'is_wff' ? _react2.default.createElement(_components.CompanyIsWff, { company: _this2.props.company }) : null,
            key === 'is_tff' ? _react2.default.createElement(_components.CompanyIsTff, { company: _this2.props.company }) : null,
            key === 'is_sjf' ? _react2.default.createElement(_components.CompanyIsSjf, { company: _this2.props.company }) : null
          );
        })
      );
    }
  }]);
  return ListSlidedowns;
}(_react.Component), _class2.propTypes = {
  company: _react.PropTypes.object.isRequired
}, _temp)) || _class);
var Company = (_dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    result: state.companydetails.result,
    loading: state.companydetails.loading,
    loaded: state.companydetails.loaded,
    error: state.companydetails.error
  };
}, searchActions), _dec3 = (0, _reactCssModules2.default)(_Company2.default, { allowMultiple: true }), _dec2(_class3 = _dec3(_class3 = (_temp2 = _class4 = function (_Component2) {
  (0, _inherits3.default)(Company, _Component2);

  function Company(props) {
    (0, _classCallCheck3.default)(this, Company);

    var _this3 = (0, _possibleConstructorReturn3.default)(this, (Company.__proto__ || (0, _getPrototypeOf2.default)(Company)).call(this, props));

    _this3.state = {
      title: 'Companies',
      description: 'See how companies are rated on environmental and social sustainability issues.',
      url: _config2.default.domain + _config2.default.routes.company
    };
    return _this3;
  }

  (0, _createClass3.default)(Company, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.companydetails(this.props.params.companyId);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var slugify = function slugify(name) {
        return name.toLowerCase() // Convert to lowercase
        .replace(/[^a-z0-9\s-]/g, '') // Remove special characters
        .replace(/\s+/g, '-') // Replace spaces with hyphens
        .replace(/-+/g, '-'); // Remove extra hyphens
      };
      if (nextProps.result && nextProps.result.result && nextProps.result.result.length > 0) {
        var a = slugify(this.props.params.shortName);
        var b = slugify(nextProps.result.result[0].short_name);
        if (a !== b) {
          this.context.router.push(_config2.default.routes.company + '/' + b + '/' + this.props.params.companyId);
        }
      }
    }

    // {market, company_id, short_name, sector, legal_name, primary_symbol, primary_exchange_id, industry_code, is_po_consumer, is_po_producer, is_po_financier, is_arms, is_to, is_tm, is_ip, is_afsc_divest, is_pp, is_borders, is_cl, is_mmc, is_cm, is_nw, is_gm, is_gr, is_c2, is_f15, is_og, is_ut, is_co, is_dirty, is_pff_high, is_pff_extreme, gef_score, gef_score_a, gef_score_b, is_fossil_bank, fossil_bank_lending_total, fossil_bank_score, is_fossil_insure, fossil_insure_score, dei_score, rji_score, hrc_score, updated_at, version, id}

    /**
     * Update the company object by combining some flags.
     *
     * @param {Object} Object to update
     */

  }, {
    key: 'updateCompanyObj',
    value: function updateCompanyObj(c) {
      c.is_fff = c.is_c2 || c.is_f15 || c.is_og || c.is_ut || c.is_co || c.is_fossil_bank || c.is_fossil_insure;
      c.is_pff = c.is_pp || c.is_borders;
      c.is_p = c.is_pp && !c.is_pff_high;
      c.is_b = c.is_borders && !c.is_pff_high;
      c.is_prisons_high = c.is_pp && c.is_pff_high;
      c.is_borders_high = c.is_borders && c.is_pff_high;
      c.is_dff = c.is_po_consumer || c.is_po_producer || c.is_po_financier;
      c.is_gff = c.is_gm || c.is_gr;
      c.is_wff = c.is_mmc;
      c.is_tff = c.is_to || c.is_tm;
      c.is_sjf = c.gef_score; //  || c.dei_score || c.rji_score || c.hrc_score
      return c;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.result) {
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, {
            options: { scale: 0.70, top: '2.0rem' },
            loaded: false
          })
        );
      } else if (!this.props.result.result || this.props.result.result.length <= 0) {
        this.context.router.push(_config2.default.routes.notFound);
      }

      var company = this.updateCompanyObj(this.props.result.result[0]);

      return _react2.default.createElement(
        'div',
        { styleName: 'main' },
        _container2.default.helmet(company.short_name + ' - ' + this.state.title, this.state.description, this.state.url),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'header',
            { styleName: 'header' },
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                _components.Link,
                { to: _config2.default.routes.companies, title: 'Companies', xstrong: true },
                '\u2190 Back to all companies'
              )
            ),
            _react2.default.createElement(
              'p',
              { styleName: 'name-label' },
              'Company profile'
            ),
            _react2.default.createElement(
              'h1',
              null,
              company.short_name
            ),
            _react2.default.createElement(
              'p',
              { styleName: 'data-label' },
              _react2.default.createElement(
                'span',
                null,
                'Legal name'
              ),
              _react2.default.createElement(
                'span',
                null,
                company.legal_name
              )
            ),
            _react2.default.createElement(
              'p',
              { styleName: 'data-label' },
              _react2.default.createElement(
                'span',
                null,
                'Primary symbol'
              ),
              _react2.default.createElement(
                'span',
                null,
                company.primary_symbol
              )
            )
          ),
          _react2.default.createElement(
            'h2',
            null,
            'Environmental & Social Issues'
          ),
          _react2.default.createElement(ListSlidedowns, { company: company })
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null)
      );
    }
  }]);
  return Company;
}(_react.Component), _class4.propTypes = {
  loading: _react.PropTypes.bool,
  loaded: _react.PropTypes.bool,
  error: _react.PropTypes.object,
  result: _react.PropTypes.object
}, _class4.contextTypes = {
  router: _react.PropTypes.object.isRequired
}, _temp2)) || _class3) || _class3);
exports.default = Company;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Company/Company.js
// module id = 1469
// module chunks = 0